export default function setValue(name: string, value: string) {
  const input: HTMLInputElement | null = document.querySelector(`[name="${name}"]`)

  if (!input) return

  input.value = value
}
